<template>
  <div>
    <b-navbar type="dark" variant="info" style="justify-content: space-between;">
      <b-navbar-brand>
        <img :src="require('@/assets/logo.png')" class="d-inline-block align-top" alt="logo" width="6%"
          height="6%" />
          线路人形监控系统
      </b-navbar-brand>



      <div class="right">
        <div v-if="role == '0'" style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;"
          @click="navigateToSettings">系统设置</div>
        <div 
        v-if="role == '0'"
        style="padding: 0 50px 0 0;cursor: pointer; font-size: 18px;color: #fff;" 
        @click="navigateToControl"
        >监控点管理
        </div>
        <div style="cursor: pointer" @click="navigateToUser" v-if="role == '0'">
          <img :src="require('@/assets/user.png')" class="d-inline-block align-top" alt="logo" width="50px"
            height="50px" />
        </div>
        <div style="padding: 0 50px 0 50px;cursor: pointer; font-size: 18px;color: #fff;" @click="navigateToLogout">
          退出
        </div>

      </div>
    </b-navbar>

    <b-container fluid class="mt-2">
      <b-card no-body>
        <b-breadcrumb>
          <b-breadcrumb-item @click="navigateToHome">
            <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
            首页
          </b-breadcrumb-item>
          <b-breadcrumb-item active>系统设置</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="btn3">
          <button style="margin-right: 10px;" type="button" class="btn btn-primary"
            @click="handleOpenDetail(item)">修改系统设置</button>
        </div>
        <table class="table table-striped" id="vcfResult">
          <thead>
            <tr>
              <th scope="col" id="addressList">UDP消息发送列表(多个用 ; 分隔)</th>
              <th scope="col" id="logSavePath">日志保存地址</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ item.addressList }}</td>
              <td>
                {{ item.logSavePath }}
              </td>
            </tr>

          </tbody>
        </table>


      </b-card>
    </b-container>
    <b-modal no-close-on-backdrop no-close-on-esc v-model="show" title="系统设置">
      <div class="modal-box">
        <b-form>
          <b-form-group id="input-group-1" label="UDP消息发送列表(多个用 ; 分隔)" label-for="input-1">
            <b-form-input id="input-1" v-model="form.addressList"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="日志保存地址" label-for="input-1">
            <b-form-input id="input-2" v-model="form.logSavePath"></b-form-input>
          </b-form-group>
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-button type="reset" variant="danger" @click="show = false">取消</b-button>
        <b-button type="submit" variant="primary" @click="handleSaveDevice">确定</b-button>
      </template>
    </b-modal>

  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Settings',
  created() {
    this.role = window.localStorage.getItem('role');
    this.getSetting()
  },
  data() {
    return {
      show: false,

      form: {
        urlBase: '',
        videoBase: '',
        photoBase: '',
        photoInterval: '',
        // ---------------------------------------------------------------------------------------------------------------------
        playTime: ''
      },
      item: {

      }
    };
  },
  methods: {
    navigateToUser() {
      this.$router.push({
        path: '/usermanage'
      })
    },
    navigateToControl() {
      this.$router.push({
        path: '/control'
      })
    },
    navigateToHome() {
      this.$router.push({
        path: '/home'
      })
    },
    navigateToSettings() {
      this.$router.push({
        path: '/settings'
      })
    },
    // 获取列表
    getSetting() {
      axios.get(`${this.$apiRoot}/system/getSetting`)
        .then((response) => {
          this.item = response.data.data
        })
    },

    //编辑
    handleOpenDetail(item) {
      this.form['addressList'] = item.addressList;
      this.form['logSavePath'] = item.logSavePath;
      this.show = true;

    },


    handleSaveDevice() {
      // if (this.form.urlBase == ''||this.form.videoBase == ''
      // ||this.form.photoBase == ''||this.form.photoInterval == '') {
      //   alert("系统设置项不能为空！！！")
      //   return
      // }
      // -------------------------------------------------------------------------------------------------------------------------------
      if (this.form.addressList == '') {
        alert("系统设置项不能为空！！！")
        return
      }
      let info = {
        addressList: this.form.addressList,
        logSavePath: this.form.logSavePath
      }
      axios.post(`${this.$apiRoot}/system/setting`, info)
        .then(res => {
          var code = res.data.code;
          if (code == 200) {
            alert("修改成功！");
            this.getSetting()
            this.show = false
          } else {
            alert("修改错误!");
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    //退出登录


    navigateToLogout() {

      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('是否退出登录?', {
        title: '请确认',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '退出',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            window.localStorage.removeItem('username')
            window.localStorage.removeItem('password')
            window.localStorage.removeItem('role')
            window.localStorage.removeItem('token')
            this.$router.push({
              path: '/'
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err);
        })

    },

  }
}

</script>
<style>
.btn3 {
  /* padding: 0 0 20px 80%
   */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding-bottom: 20px;
}

.modal-box1 {
  width: 800px;
  margin-left: auto;
  margin-right: auto;
  /* margin-bottom: 300px; */
}
</style>
